import { TypeIdSchema } from '@unipile/db';
import { Static, Type } from '@sinclair/typebox';
import { ProviderSchema } from '../common/provider.schema';

export const ProviderAuthorizationTokenSchema = Type.Object({
  object: Type.Literal('ProviderAuthorizationToken'),
  token: Type.String(),
});

export const ProviderAuthenticationPayloadSchema = Type.Object({
  object: Type.Literal('ProviderAuthenticationPayload'),
  user_id: Type.String(),
  user_name: Type.String(),
  authorization: Type.String(),
  provider: ProviderSchema,
  account_id: TypeIdSchema('account'),
  oauth_scope: Type.Optional(Type.Array(Type.String())),
});

export type ProviderAuthorizationToken = Static<typeof ProviderAuthorizationTokenSchema>;
export type ProviderAuthenticationPayload = Static<typeof ProviderAuthenticationPayloadSchema>;
